import { useTranslation } from 'react-i18next';
import { Button } from '@opswat/ui';
import { Link } from 'components/Link';
import { useGTM } from 'hooks/useGTM';
import notFound from 'images/notFound.svg';

export const LicenseError = () => {
    const { t } = useTranslation();
    const { trackClick } = useGTM();

    return (
        <div className='tw:flex tw:flex-col tw:items-center tw:justify-center tw:w-full tw:h-full tw-m-auto'>
            <img src={notFound} draggable={false} alt={t('Not found icon')} />
            <div className='tw:flex tw:flex-col tw:gap-32 tw:items-center tw:justify-between'>
                <div className='tw:md:w-580 tw:px-10 tw:flex tw:flex-col tw:gap-9 tw:justify-between tw:text-center'>
                    <span className='tw:text-headline'>{t('License Not Available')}</span>
                    <span className='tw:text-body tw:text-neutrals-800 tw:dark:text-neutrals-500'>{t('It appears that your OPSWAT account does not have a MetaDefender Cloud commercial license. Please contact OPSWAT sales for assistance.')}</span>
                </div>
                <div className='tw:flex tw:flex-row tw:gap-8 tw:m-auto'>
                    <Link to='https://www.opswat.com/get-started' isExternal className='tw:m-auto'>
                        <Button
                            variant='primary'
                            className='tw:font-medium tw:px-8'
                            text={t('Contact sales')}
                            onClick={() => trackClick('contact-sales-button', 'ui', 'Contact sales Button Clicked')}
                        />
                    </Link>
                    <Link to='/licensing' className='tw:m-auto'>
                        <Button
                            variant='secondary'
                            className='tw:font-medium tw:px-8'
                            text={t('Licensing')}
                            onClick={() => trackClick('contact-sales-button', 'ui', 'Contact sales Button Clicked')}
                        />
                    </Link>
                </div>
                <div className='tw:text-note'>
                    {t('You are currently viewing MetaDefender Cloud for commercial users. For community solutions, please visit ')}
                    <Link to='https://metadefender.com' isExternal isNote isBrand >
                        {t('metadefender.com')}
                    </Link>
                </div>
            </div>
        </div>
    );
};
